import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import {
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN,
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_ERROR,
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_SUCCESS,
} from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetDashboardDetailsCSRFToken({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/security/csrf_token/`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_ERROR, payload: error });
  }
}

export function* watchSupersetDashboardDetailsCSRFToken() {
  yield takeEvery(SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN, supersetDashboardDetailsCSRFToken);
}

function* supersetDashboardDetailsCSRFTokenSaga() {
  yield all([fork(watchSupersetDashboardDetailsCSRFToken)]);
}

export default supersetDashboardDetailsCSRFTokenSaga;
